import { loadStripe } from '@stripe/stripe-js';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!publishableKey) {
  throw new Error('REACT_APP_STRIPE_PUBLISHABLE_KEY is not set');
}

export const stripePromise = loadStripe(publishableKey);
